import * as $ from 'jquery';
import { $map, isSafari } from './variables';
import LazyLoad from "vanilla-lazyload";


/**
 * 
 * this method adjusts the layout of the map module
 * 
 * @param windowwidth current width of the window
 */

function adjustGeoMapOnSafari(windowwidth) {
  if (windowwidth >= 770 && isSafari) {
    if ($map.length) {
      // adjust the top position of the map container, so it shows up on desktop 
      $map.css('top', '750px');
    }
  }
}


function adjustHeaderBg() {
  // only exists one time on a page
  const $elem = $('.js__hero_bg');

  if ($elem.length) {
    let offset = $('.js__hero_media').offset()?.top ?? 0;
    let height = ($('.js__hero_media').height() ?? 0) / 2;
    let bg_height = offset + height + "px";
    $elem.css('height', bg_height);
  }
}

function adjustContentBlockBg() {
  let $elems = $('.js__to_be_aligned');
  if ($elems.length) {
    $elems.each((index, elem) => {
      let $elem = $(elem);
      let $aligner = $elem.parent().find('.js__center_align');
      let offset = $aligner.position().top;
      let height = ($aligner.height() ?? 0) / 2;
      let bg_top = offset + height + "px";
      $elem.css('top', bg_top);
    });
  }
}

function adjustCaseBg() {
  // only exists one time on a page
  const $elem = $('.js__case_bg');

  if ($elem.length) {
    let offset = $('.js__hero_media').offset()?.top ?? 0;
    let height = ($('.js__hero_media').height() ?? 0) - 90;
    let bg_height = offset + height + "px";
    $elem.css('height', bg_height);
  }
}


const lazyLoadInstance = new LazyLoad({
  callback_finish: () => {
  },
  callback_loaded: (element) => {
    $(element).removeClass('skeleton');
  },
  callback_error: (element) => {
    console.error('error loading ' + $(element).data('src'));
  }
}, document.querySelectorAll('.skeleton'));

function showLazyElements() {


  // $('.lazy').Lazy({
  //   scrollDirection: 'vertical',
  //   effect: 'fadeIn',
  //   effectTime: 200,
  //   visibleOnly: true,
  //   onError: (element) => {
  //   },
  //   afterLoad: (element) => {
  //     element.removeClass('skeleton');
  //   }
  // });
}

$.fn.extend({
  isInViewport: function (offsetTop, offsetBottom) {
    if (!offsetTop) {
      offsetTop = 0;
    }
    if (!offsetBottom) {
      offsetBottom = 0;
    }
    let elementTop = $(this).offset()?.top ?? 0 + offsetTop;
    let outterHeight = $(this).outerHeight() ?? 0;
    let elementBottom = elementTop + outterHeight - offsetBottom;

    let viewportTop = $(window).scrollTop() ?? 0;
    let windowHeight = $(window).height() ?? 0;
    let viewportBottom = viewportTop + windowHeight;

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }
});


export { adjustGeoMapOnSafari, adjustHeaderBg, adjustContentBlockBg, adjustCaseBg, lazyLoadInstance }; 